import { useTheme } from '@emotion/react'

import {
  AllerganMonoLogo,
  CampingWorldMonoLogo,
  FenderMonoLogo,
  TillsterMonoLogo,
} from '@segment/matcha/components/CompanyLogos/CompanyMono'
import {
  AllerganLogo,
  CampingWorldLogo,
  FenderLogo,
  TillsterLogo,
} from '@segment/matcha/components/CompanyLogos/Company'

const testimonialData = () => {
  const theme = useTheme()
  return [
    {
      company: `allergan`,
      text: (
        <>
          “We lean heavily on Segment today to identify our consumers and their profile traits, what makes them them,
          and what kind of journey they are on. So, being able to have that integration with Twilio to be able to send
          communications to users based on their journey status is a pivotal piece of bringing those magic moments to
          life.”
        </>
      ),
      name: `Tory Brady`,
      position: `Associate Vice President, Product, Engineering & Data at Allergan Data Labs`,
      logo: <AllerganMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <AllerganLogo />,
      logoName: `Allergan`,
      extendedRate: `400M+`,
      extendedText: `in sales driven in 2021 YTD by direct-to-consumer (DTC)`,
      extendedLink: `/customers/allergan/`,
    },
    {
      company: `camping-world`,
      text: (
        <>
          “We now have a better understanding of our target market ‘outdoor enthusiasts' which enables us to{` `}
          <mark>become the one-stop-shop for our customers’ RV needs.</mark>.“
        </>
      ),
      name: `Brad Greene`,
      position: `Senior Director of Marketing Technology`,
      logo: <CampingWorldMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <CampingWorldLogo />,
      logoName: `CampingWorld`,
      extendedRate: `35%`,
      extendedText: `increase in sales leads`,
      extendedLink: `/customers/camping-world/`,
    },
    {
      company: `fender`,
      text: (
        <>
          To increase adoption and retention rates, Fender uses tools from Twilio Segment to optimize the customer sales
          funnel by streamlining the onboarding process.
        </>
      ),
      logo: <FenderMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <FenderLogo />,
      logoName: `Fender`,
      extendedRate: `29%`,
      extendedText: `reduction in customer churn rate for paid app`,
      extendedLink: `/customers/fender/`,
    },
    {
      company: `tillster`,
      text: <>“With Segment, we are able to use more personalization and intelligent targeting“</>,
      name: `Adam Morse`,
      position: `Senior Director of Marketing`,
      logo: <TillsterMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <TillsterLogo />,
      logoName: `Tillster`,
      extendedRate: `3X`,
      extendedText: `repurchase rates`,
      extendedLink: `/customers/tillster/`,
    },
  ]
}

export { testimonialData }
